import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs';
import { UTC_DATE_REGEX } from '../../constants/system-constants.model';

export const DateFormatInterceptor: HttpInterceptorFn = (req, next) => {
    return next(req).pipe(
        map(event => {
            if (event instanceof HttpResponse) {
                const modifiedBody = convertDateToUTC(event.body);
                return event.clone({ body: modifiedBody });
            }
            return event;
        })
    );
};

function convertDateToUTC<T>(data: T): T {
    if (data !== null && typeof data === 'object') {
        const obj = data as Record<string, unknown>;
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                const value = obj[key];
                if (isDate(value)) {
                    if (!value.endsWith('Z'))
                        obj[key] = `${value}Z`;
                } else if (typeof value === 'object')
                    obj[key] = convertDateToUTC(value);
            }
        }
    }
    return data;
}

function isDate(value: unknown): value is string {
    return typeof value === 'string' && UTC_DATE_REGEX.test(value);
}